import "./style.css";

export const SubHeaderSkeleton = ({ style }) => (
  <div className='sub-header skeleton-loader' style={style}/>
);